<template>
<div class="scrolly-content-video">
  <video
    v-if="this.attributes.background"
    :src="getSource(this.attributes.background)"
    v-bind="attrs"
    controlsList="nodownload"
    playsinline
    autobuffer
    autoplay
    loop
    muted>
  </video>
</div>
</template>

<script>
export default {
  props: ['attributes', 'enter'],
  computed: {
    attrs () {
      const {poster} = this.attributes
      return {
        poster: poster ? this.getPosterSource(poster) : null
      }
    },
    isTabletWidth () {
      return this.$window.innerWidth < 768
    },
    hasDesktopSource () {
      const {hasdesktop} = this.attributes
      return !hasdesktop || hasdesktop !== 'false'
    }
  },
  methods: {
    getPosterSource (value) {
      let path = null
      if (value) {
        const [name, ext] = value.split('.')
        path = name + (!this.isTabletWidth && this.hasDesktopSource ? '-desktop.' : '.') + ext
      }
      return path ? require(`videos/${path}`) : null
    },
    getSource (value) {
      const [name, ext] = value.split('.')
      const path = name + (!this.isTabletWidth && this.hasDesktopSource ? '-desktop.' : '.') + ext
      return require(`videos/${path}`)
    }
  },
  mounted () {
    const originalPosition = 'absolute'
    const tempPosition = 'relative'
    var isVideoFlagged = false
    if (global.isMobile) {
      // force auto play intro video on low battery mode on mobile
      const vid = this.$el.querySelector('video[autoplay]')
      var events = ['click', 'touchstart']
      for (let i in events) {
        document.addEventListener(events[i], function (ev) {
          if (
            vid.autoplay && vid.currentTime > 0 && !vid.paused && !vid.ended && vid.readyState > 2
          ) {
            if (global.isIOS() && !isVideoFlagged) {
              isVideoFlagged = true
              vid.style.position = tempPosition
              setTimeout(() => {
                vid.style.position = originalPosition
              }, 500)
            }
            // is playing don't do anything
          } else if (vid.hasAttribute('loop')) {
            vid.play()
            vid.controls = false
            vid.removeAttribute('controls')
            if (global.isIOS()) {
              vid.style.position = tempPosition
              setTimeout(() => {
                vid.style.position = originalPosition
              }, 500)
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.scrolly-content-video {
  video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}
</style>
